import {getLodop} from "@/config/LodopFuncs.js";
import {cache} from "./localCache"
import {SerialPort, dataProcess} from '../plugin/serialPort.js';
import {envElectron} from "./electronUtils";

const SUBMIT_CODE = "wms-submit-code";

export const volumeRatioOptions = [5000, 6000, 7000, 8000];
export const defaultVolumeRatio = 6000;
export const trayTypeOption = [
  {label: "lang.without", value: 0, weightKey: ''},
  {label: "lang.woodPallet", value: 1, weightKey: 'defaultWoodPalletWeight'},
  {label: "lang.ironPallet", value: 2, weightKey: 'defaultIronPalletWeight'},
  {label: "lang.paperPallet", value: 3, weightKey: 'defaultPaperPalletWeight'},
];
export const packageTypeOption = [
  {label: 'lang.cardBox', value: 0},
  {label: 'lang.woodBracket', value: 1},
  {label: 'lang.paperDrum', value: 2},
  {label: 'lang.canvasRoll', value: 3},
  {label: 'lang.wovenBag', value: 4},
  {label: 'lang.plywoodBox', value: 5},
  {label: 'lang.pagerSupport', value: 6},
  {label: 'lang.plywoodBracket', value: 7},]
export const cargoTypeOption = ["lang.fba",
  "lang.commercialExpress",
  "lang.smallParcel",
  "lang.eCommercePackage",
  "lang.directTransportation",
  "lang.generalCargo",
  "lang.sensitiveGoods",
  "lang.dangerousGoods"]
export const capacityOrderErrorOption = {//货物状态 0正常， 1破损，2受潮，3变形，4其他，5漏件，6无头件
  "0": {title: "lang.cargoWeighing", picList: [], type: 0, count: '', quantityNot: true},
  "1": {title: "lang.cargoBreakage", picList: [], type: 1, count: ''},
  "2": {title: "lang.cargoDampness", picList: [], type: 2, count: ''},
  "3": {title: "lang.cargoDeformable", picList: [], type: 3, count: ''},
  "4": {title: "lang.other", picList: [], type: 4, count: ''},
  "5": {title: "lang.cargoMissing", picList: [], type: 5, count: '', picNot: true},
}

export const capacityTypeObj = {
  "1": "lang.air",
  "2": "lang.sea",
}

/**
 * 判断单号类型
 * @param code 需要判断的单号的类型
 * @return {code: *, type: number} 单号类型 包裹码0，订单id:2，卡果单号：3，快递单号、转运单号 4 确认码 5
 */
export function judgeCodeType(code) {
  let result = {code: code, type: 4};
  let httpTel = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?/;
  if (httpTel.test(code)) {
    result.code = code.split("?qrcodeId=")[1];
    result.type = 2;
  } else if (code.indexOf("VEX") !== -1) {
    result.type = 3;
  } else if (code.length === 6) {
    result.type = 0;
  } else if (SUBMIT_CODE.indexOf(code) !== -1) {
    result.type = 5;
  } else {
    if (cache.appendCode) {
      let num = 0;
      try {
        num = Number(cache.appendCode || "0");
      } catch (e) {

      }
      if (result.code.length > num) {
        result.code = result.code.substring(num);
      }
    }
  }

  return result;
}

export function getPageDefaultHeight() {
  return window.innerHeight - 107;
}

/**
 * 提示信息
 * @param content 提示内容
 * @param type 类型
 */
export function showNotify(that, content, type = 'warning') {
  if (type !== 'success') {
    playAudio("error");
  }
  that.$message({
    message: content,
    type: type,
    duration: 8000,
    showClose: true,
    customClass: 'notify-view'
  });
}

/**
 * 调整空间焦点
 */
export function updateInputFocus(that, input) {
  that.$nextTick(function () {
    that.$refs[input] && that.$refs[input].focus();
  });
}


/*通过base64编码字符流计算文件流大小函数*/
function fileSize(str) {
  let fileSize;
  if (str.indexOf("=") > 0) {
    let indexOf = str.indexOf("=");
    str = str.substring(0, indexOf); //把末尾的’=‘号去掉
  }
  fileSize = parseInt(str.length - (str.length / 8) * 2);
  return fileSize;
}


export const videoSize = {
  width: 1280,
  height: 720
}

/**
 * 开启照相机显示
 * @param cameraId 相机布局Id
 */
export function openSingleCamera(cameraId) {
  let video = document.getElementById(cameraId);
  // &&navigator.mediaDevices.hasOwnProperty('getUserMedia')
  if (navigator.mediaDevices) {
    navigator.mediaDevices.getUserMedia({
      video: videoSize,
      audio: false
    }).then((mediaStream) => {
      video.srcObject = mediaStream;
      video.play();
    }).catch(error => {
      console.log(error);
    });
  } else {
    console.log("不支持相机功能")
  }
}


/**
 * 开启照相机显示
 * @param videoCreateIdsFun 创建多video标签回调方法 返回[{labelId:"标签ID",deviceId："摄像头id"}]
 */
export function openMultiCamera(videoCreateIdsFun) {
  let mediaDevices = navigator.mediaDevices;
  // &&navigator.mediaDevices.hasOwnProperty('getUserMedia')
  if (!mediaDevices) {
    console.log("Not support camera");
    return;
  }
  mediaDevices.enumerateDevices().then(devices => {
    let videoList = [];
    for (let item of devices) {
      if (item.kind === 'videoinput') {
        videoList = videoList.concat(item);
      }
    }

    let videoIds = videoCreateIdsFun(videoList);//[{labelId:"标签ID",deviceId："摄像头id"}]
    setTimeout(function () {
      for (let videoItem of videoIds) {
        let video = document.getElementById(`${videoItem.labelId}`);
        navigator.mediaDevices.getUserMedia({
          video: {
            width: videoSize.width,
            height: videoSize.height,
            deviceId: videoItem.deviceId,
          },
          audio: false
        }).then((mediaStream) => {
          video.srcObject = mediaStream;
          video.play();
        }).catch(error => {
          console.log(error);
        });
      }
    }, 500)
  })
}

/**
 * 拍照指令
 * @param that 页面上下文
 * @param cameraId 相机布局Id
 * @param canvasId canvasId
 * @param callback 图片上传七牛回调 成功会返回七牛的网络路径
 */
export async function takePictureClick(that, cameraId, canvasId) {
  return new Promise(function (resolve, reject) {
    getQiniuToken(that).then(qiNiuToken => {
      try {
        let video = document.getElementById(cameraId);
        let canvas = document.getElementById("canvas-wms");
        let ctx = canvas.getContext('2d');
        // 画图操作
        ctx.drawImage(video, 0, 0, videoSize.width, videoSize.height);

        // ctx.drawImage(video, 0, 0, 300, 150);
        // toDataURL  ---  可传入'image/png'---默认, 'image/jpeg'
        // 在页面显示base64图片处理
        // var Imagedata = canvas.toDataURL().substring(22); // 注意：上传给后台的图片数据！
        let picBase = canvas.toDataURL("image/png", "1.0"); // 注意：上传给后台的图片数据！
        // 转换图片
        /*把头部的data:image/png;base64,去掉。（注意：base64后面的逗号也去掉）*/
        picBase = picBase.substring(22);
        let url = "https://upload.qiniup.com/putb64/" + fileSize(picBase);
        let xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
            /*返回的key是字符串，需要装换成json*/
            let keyText = JSON.parse(xhr.responseText);
            /* 七牛云空间网址，keyText.key 是返回的图片文件名*/
            if (keyText.key) {
              resolve(`https://qiniu.mrcargo.com/${keyText.key}`)
              return;
            }
            reject("upload pic fail");
          }
        };
        xhr.open("POST", url, true);
        xhr.setRequestHeader("Content-Type", "application/octet-stream");
        xhr.setRequestHeader(
          "Authorization",
          "UpToken " + qiNiuToken
        );
        xhr.send(picBase);
      } catch (e) {
        reject("paint pic fail");
        console.log('绘制图片出现异常:'+e);
      }
    })
  })
}

export function takeMultiPicClick(that, videoList, imgListCallBak) {
  let uploadCount = 0;
  let imgList = [];
  for (let item of videoList) {
    takePictureClick(that, item.labelId, item.canvasId).then(res => {
      imgList = imgList.concat(res);
      if (++uploadCount === videoList.length) {
        imgListCallBak(imgList);
      }
    }).catch(error => {
      if (++uploadCount === videoList.length) {
        imgListCallBak(imgList);
      }
    })
  }
}


export function getQiniuToken(that) {
  return new Promise(function (resolve, reject) {
    if (cache.msg.timestamp && Math.abs((new Date()).getTime() - cache.msg.timestamp) < 864000 * 100) {
      if (cache.msg.qinniutoken) {
        resolve(cache.msg.qinniutoken);
        return;
      }
    }

    that.$post(that.baseUrl + "sysOperUser/operGetQiniuToken", {
      token: cache.msg.token,
    }).then(res => {
      let msg = cache.msg;
      msg.timestamp = (new Date()).getTime();
      msg.qinniutoken = res.value;
      cache.msg = msg
      resolve(res.value)
    }).catch(error => {

    })
  })
}

//磅秤对象
let serial;

/**
 * 获取磅秤操作对象
 * @param that 页面上下文
 * @param extensionId 浏览器扩展程序Id
 * @returns {*} 返回磅秤操作对象
 */
export function getSerialPort(that, extensionId) {
  try {
    if (!extensionId) {
      //如果没穿扩展Id 则获取是否保存过的id
      extensionId = cache.weightSetting && cache.weightSetting.extensionId ? cache.weightSetting.extensionId : "";
      if (!extensionId) {
        //没有保存 提示用户前往设置
        showNotify(this, this.$t('lang.setWeightNotify'))
      } else {
        //复用对象 当存在直接返回 反之 创建新的对象
        if (!serial) {
          serial = SerialPort(extensionId)
        }
      }
    } else {
      //设置扩展Id 直接创建新的对象 并返回
      serial = SerialPort(extensionId)
    }
  } catch (e) {
    console.log("连接磅秤失败，请检测插件ID是否正确")
  }

  return serial;
}

/**
 * 打开或关闭磅秤
 * @param that 页面上下文
 * @param status 开启关闭状态
 */
export function openOrCloseWeight(that, status, dataListener) {
  if (cache.outDeviceModel != 1) {
    return;
  }

  if (envElectron()) {//electron环境 触发electron磅秤方法
    openOrCloseWeightForElectron(that, status, dataListener);
    return;
  }

  if (!serial) {
    if (status) {
      if (getSerialPort(that)) {
        setTimeout(function () {
          openOrCloseWeightOperation(that, status, dataListener)
        }, 500);
      }
    }
  } else {
    openOrCloseWeightOperation(that, status, dataListener)
  }
}

/**
 * electron 打印工作
 * @param printList 打印列表
 */
function openOrCloseWeightForElectron(that, status, dataListener) {
  if (cache.weightSetting.portName) {
    window.ipcRenderer.send("controlSerialPortServer", {
      status: (status ? "open" : "close"),
      path: cache.weightSetting.portName
    });
    //读取货物信息
    window.ipcRenderer.on("serialPortInfo", (event, arg) => {
      let str = dataProcess(arg);
      if (str !== undefined) {
        dataListener(str);
      }
    });
  }
}


function openOrCloseWeightOperation(that, status, dataListener) {
  try {
    if (status) {
      //开启磅秤操作
      if (!serial.isOpen()) {
        serial.openPort({
            portName: cache.weightSetting.portName,//开启端口名称
            bitrate: 9600,//频率
            dataBits: "eight",
            parityBit: "no",
            stopBits: "one"
          },
          function (response) {
            //开启返回 成功还是失败
            console.log(response);
            if (response.result === "ok") {
              //添加输出数据绑定事件
              serial.setOnDataReceivedCallback(dataListener)
              return;
            }

            showNotify(that, that.$t('lang.failConnectWeightSuggestOne'))
          });
      }
    } else {
      //关闭磅秤操作
      if (serial.isOpen()) {
        serial.closePort(function (response) {
          console.log(response);
          if (response.result === "ok") {
            //Do something
          } else {
            if (response.error !== 'Serial connection not found.') {
              showNotify(that, that.$t('lang.failConnectWeightSuggestOne'))
              return;
            }

            showNotify(that, that.$t('lang.failConnectWeightSuggestTwo'))
          }
        });
      }
      serial.setOnDataReceivedCallback(undefined)
    }
  } catch (e) {
    console.log("浏览器不支持重量控件");
  }
}


/**
 * 调用打印机
 * @param that 页面上下文
 * @param isPreview 是否预览
 * @param imageList 打印网络图片的路径
 * @param lopod 打印对象
 */
export function printerForLodop(that, isPreview, imageList, lopod = null) {
  if (imageList.length === 0) {
    showNotify(that, that.$t('lang.nothingToPrintYet'))
    return;
  }

  if (envElectron()) {//electron环境 触发electron打印方法
    printForElectron(that, imageList);
    return;
  }

  return new Promise((resolve, reject) => {
    let mLodop = lopod || getLodop();
    if (!mLodop) {//用户未安装lopod 直接浏览器预览面单
      showNotify(that, that.$t('lang.printFailNotify'));
      for (let item of imageList) {
        if (item.type === 'barcode') {
          window.open(`${that.baseUrl}system/getJBarcodeG?code=${item.url}`, '_blank');
        } else {
          window.open(item.url, '_blank');
        }
      }
      return;
    }

    //lopod 使用lopod进行打印工作
    if (!lopod) {
      mLodop.PRINT_INIT("面单");
      if (that.localCache.printerId !== "") {
        mLodop.SET_PRINTER_INDEX(`${that.localCache.printerId},`);
      }
    }
    addImageToLopod(that, mLodop, imageList, 0, imageList.length - 1, isPreview);
    resolve();
  })

}

/**
 * electron 打印工作
 * @param printList 打印列表
 */
function printForElectron(that, printList) {
  let sendObj = {printerName: "",};
  for (let item of printList) {
    if (!item.url) {
      showNotify(that, that.$t('lang.failGetLabel'));
      return;
    } else if (item.type === 'barcode') {
      sendObj.html = `<img src="${that.baseUrl}system/getJBarcodeG?code=${item.url}"/>`;
    } else if (item.type === 'image') {
      sendObj.html = `<img src="${item.url}"/>`;
    } else if (item.type === 'pdf') {
      sendObj.pdfUrl = item.url;
    } else {
      return;
    }
    //向electron端发送打印事件通知
    window.ipcRenderer.send('do-print', sendObj);
  }
}

/**
 * lodop 打印方法
 * @param that 上下文
 * @param lodop lodop对象
 * @param imageList 打印列表
 * @param i 需要打印下标
 * @param count 打印数量
 * @param isPreview 是否需要预览
 */
function addImageToLopod(that, lodop, imageList, i, count, isPreview) {
  // lodop.ADD_PRINT_IMAGE(0, 0, "100%", "100%", "<img src='" + imageList[i] + "'/>");
  if (imageList[i].type === 'barcode') {
    imageList[i].type = 'image';
    imageList[i].url = `${that.baseUrl}system/getJBarcodeG?code=${imageList[i].url}`;
  }

  if (!isPreview) {
    isPreview = that.localCache.previewPrint
  }

  if (!imageList[i].url) {
    showNotify(that, that.$t('lang.failGetLabel'))
    nextLopod(that, lodop, imageList, i, count, isPreview);
  } else if (imageList[i].type === 'image') {
    let image = new Image();
    image.src = imageList[i].url;
    image.setAttribute("crossOrigin", 'Anonymous') // 解决控制台跨域报错的问题（没用就跟后台沟通添加跨域）
    image.onload = function (res) {
      let canvas = document.createElement("canvas");
      //设置画布宽高与图片宽高相同
      canvas.width = image.width;
      canvas.height = image.height;
      //绘制图片
      canvas.getContext("2d").drawImage(image, 0, 0, canvas.width, canvas.height);
      // 打印
      lodop.SET_PRINT_MODE("POS_BASEON_PAPER", true);
      if (image.width > image.height) {
        lodop.SET_PRINT_PAGESIZE(2);
      } else {
        lodop.SET_PRINT_PAGESIZE(1);
      }
      lodop.ADD_PRINT_IMAGE(20, 20, "100%", "100%", canvas.toDataURL('image/jpg'));
      // lodop.SET_PRINT_MODE("PRINT_PAGE_PERCENT", "Auto-Width"); //(可变形)扩展缩放模式
      lodop.SET_PRINT_MODE("FULL_WIDTH_FOR_OVERFLOW", true);
      lodop.SET_PRINT_MODE("FULL_HEIGHT_FOR_OVERFLOW", true);
      image = null;
      canvas = null;
      nextLopod(that, lodop, imageList, i, count, isPreview);
    };
    image.onerror = function (error) {
      showNotify(that, that.$t('lang.failGetLabel'))
      image = null;
      nextLopod(that, lodop, imageList, i, count, isPreview);
    }
  } else if (imageList[i].type === 'barcode') {
    lodop.ADD_PRINT_BARCODE(20, 20, "300", "80", "EAN128C", imageList[i].url);
    lodop.SET_PRINT_STYLEA(0, "AlignJustify", 2);
    nextLopod(that, lodop, imageList, i, count, isPreview);
  } else if (imageList[i].type === 'pdf') {
    if (!(/^https?:/i.test(imageList[i].url))) {
      lodop.ADD_PRINT_PDF(0, 0, "100%", "100%", imageList[i].url);
      nextLopod(that, lodop, imageList, i, count, isPreview);
    } else {
      console.log(imageList[i].url)
      lodop.ADD_PRINT_PDF(0, 0, "100%", "100%", imageList[i].url.replace("https", "http"));
      lodop.SET_PRINT_STYLEA(0, "PDFScalMode", 2);
      nextLopod(that, lodop, imageList, i, count, isPreview);
      // axios.get(imageList[i].url, {
      //   responseType: 'blob'
      // }).then(res => {
      //   const dataInfo = res.data
      //   let reader = new FileReader()
      //   reader.readAsDataURL(dataInfo)
      //   reader.onload = function (e) {
      //     lodop.ADD_PRINT_PDF(0, 0, "100%", "100%", e.target.result.replace('data:application/pdf;base64,', ''));
      //     lodop.SET_PRINT_STYLEA(0, "PDFScalMode", 2);
      //     nextLopod(that, lodop, imageList, i, count, isPreview);
      //   }
      //   // res = res.dat
      //   // let dataArray;
      //   // if (typeof Uint8Array !== 'undefined') {
      //   //   dataArray = new Uint8Array(res);
      //   // } else {
      //   //   dataArray = VBS_BinaryToArray(data).toArray(); //兼容IE低版本
      //   // }
      // }).catch(error => {
      //   showNotify(that, that.$t('lang.failGetLabel'))
      //   nextLopod(that, lodop, imageList, i, count, isPreview);
      // })
    }
  }
}

function nextLopod(that, lodop, imageList, i, count, isPreview) {
  lodop.NewPage();
  if (i === count) {
    if (isPreview) {
      lodop.PREVIEW(); //预览打印
    } else {
      lodop.PRINT(); //直接打印
    }
  } else {
    i++;
    addImageToLopod(that, lodop, imageList, i, count, isPreview)
  }
}

let audio = new Audio();

// audio.muted = true;//避免直接加载 用户无操作 chrome报错问题

/**
 * 播放外放语音
 */
export function playAudio(type) {
  let mp3 = "";
  switch (type) {
    case "inStoreErrorSuccess":
      // 异常件已入库
      mp3 = "../../static/audio/in_store_error.mp3";
      break;
    case "inStoreSuccess":
      // 正常件已入库
      mp3 = "../../static/audio/in_store_success.mp3";
      break;
    case "errorOrder":
      mp3 = "../../static/audio/error.mp3";
      break;
    case "error":
      // 错误提示音
      mp3 = "../../static/audio/error.mp3";
      break;
    case "spellBagSuccess":
      mp3 = "../../static/audio/spell_success.mp3";
      break;
    case "spellBagCancel":
      mp3 = "../../static/audio/cancel_spell.mp3";
      break;
    case "outWeight":
      mp3 = "../../static/audio/out_weight.mp3";
      break;
    case "outStoreSuccess":
      mp3 = "../../static/audio/out_store_success.mp3";
      break;
    case "packSuccess":
      mp3 = "../../static/audio/pack_success.mp3";
      break;
    case "pick":
      mp3 = "../../static/audio/cargo_sorted.mp3";
      break;
    case "collectSuccess":
      mp3 = "../../static/audio/collect_success.mp3";
      break;
    case "collectCargo":
      mp3 = "../../static/audio/collect_cargo.mp3";
      break;
    case "美中":
      mp3 = "../../static/audio/american_center.mp3";
      break;
    case "美西":
      mp3 = "../../static/audio/american_west.mp3";
      break;
    case "美东":
      mp3 = "../../static/audio/american_east.mp3";
      break;
    default:
      return;
  }
  audio.src = mp3;
  audio.load();
  audio.play().then(r => {

  }).catch(error => {
    console.log("audio.play fail")
  });
}


//返回值：arg1加上arg2的精确结果
export function addFloat(arg1, arg2) {
  let r1, r2, m;
  try {
    r1 = arg1.toString().split(".")[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split(".")[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  return (arg1 * m + arg2 * m) / m
}

//减法的代码：
export function subFloat(arg1, arg2) {
  let r1, r2, m, n;
  try {
    r1 = arg1.toString().split(".")[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split(".")[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2));
  //last modify by deeka
  //动态控制精度长度
  n = (r1 >= r2) ? r1 : r2;
  return ((arg1 * m - arg2 * m) / m).toFixed(n);
}

export function mulFloat(arg1, arg2) {
  let m = 0, s1 = arg1.toString(), s2 = arg2.toString();
  try {
    m += s1.split(".")[1].length
  } catch (e) {
  }
  try {
    m += s2.split(".")[1].length
  } catch (e) {
  }
  return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
}

export function divFloat(arg1, arg2) {
  let t1 = 0, t2 = 0, r1, r2;
  try {
    t1 = arg1.toString().split(".")[1].length
  } catch (e) {
  }   //--小数点后的长度
  try {
    t2 = arg2.toString().split(".")[1].length
  } catch (e) {
  }  //--小数点后的长度
  r1 = Number(arg1.toString().replace(".", ""))  //--去除小数点变整数
  r2 = Number(arg2.toString().replace(".", ""))  //--去除小数点变整数
  if (t2 >= t1) {
    return (r1 / r2) * Math.pow(10, t2 - t1);   //---整数相除 在乘上10的平方  小数点的长度
  } else {
    return (r1 / r2) / Math.pow(10, t1 - t2);   //---整数相除 在乘上10的平方  小数点的长度
  }
}

/**
 * 获取当前日期
 * @return {string}
 */
export function getDate() {
  let date = new Date();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  return date.getFullYear() + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
}

/**
 * 校验数字是否正确
 * @param num
 * @param zeroStatus 判断是否是0
 * @return {boolean}
 */
export function judgeNumberError(num, zeroStatus = false) {
  if (num === undefined || num === "" || Number(num) < 0) {
    return true;
  } else {
    if (zeroStatus && Number(num) === 0) {
      return true
    }
    return false;
  }
}

/**
 * 获取当前局域网ip
 * @param onNewIP
 */
export function getUserIP(onNewIP) {
  let MyPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
  let pc = new MyPeerConnection({
    iceServers: []
  });
  let noop = () => {
  };
  let localIPs = {};
  let ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g;
  let iterateIP = (ip) => {
    if (!localIPs[ip]) onNewIP(ip);
    localIPs[ip] = true;
  };
  pc.createDataChannel('');
  pc.createOffer().then((sdp) => {
    sdp.sdp.split('\n').forEach(function (line) {
      if (line.indexOf('candidate') < 0) return;
      line.match(ipRegex).forEach(iterateIP);
    });
    pc.setLocalDescription(sdp, noop, noop);
  }).catch((reason) => {
  });
  pc.onicecandidate = (ice) => {
    if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return;
    ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
  };

}

/**
 * 设置本地语言
 * @param that 上下文
 * @param command 设置语言
 */
export function setLanguage(that, command) {
  that.$i18n.locale = command
  document.title = that.$t('lang.wms');
  sessionStorage.setItem('lang', command)
  if (command === 'zh-cn') {
    that.currentLang = '简体中文'
  } else if (command === 'en') {
    that.currentLang = 'English'
  }
}




// WEBPACK FOOTER //
// ./src/api/getData.js